import NavBar from './navbar';
import NavMenu from './navmenu';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import * as UI from '../slices/uiSlice';
import * as Cases from '../slices/casesSlice';
import * as Forms from '../slices/formsSlice';
import TrackerChart from './trackerchart';
import { AnyAction } from '@reduxjs/toolkit';
import TrackerPercent from './trackerpercent';
import { doFormOnChange, getFormValueWithId, getJSONWithFormValues, validateForm } from '../utilities';
import { useEffect } from 'react';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import hub_logo from '../assets/Main_Hub_Icon_Large.svg';
import icon_mainhub from '../assets/MainHub_White.svg';
import icon_wishlist from '../assets/Wishlist_White.svg';
import icon_team from '../assets/The_Team_White.svg';
import { useMediaQuery } from 'react-responsive';

const LinkedCase = () => {
	const uiState = useAppSelector(state => state.ui);
	const cases = useAppSelector(state => state.cases);
	const user = useAppSelector(state => state.user);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const handleMediaQueryChange = (matches: boolean) => {
	}
	const isTabletOrMobile = useMediaQuery({ maxWidth: 1024, orientation: 'portrait' }, undefined, handleMediaQueryChange);

	const handleScroll = () => {
		dispatch((UI.closeMenu()) as unknown as AnyAction);
	};

	const isCaseOwned = (cn: string): boolean => {
		for (const c of cases.cases) {
			if (c.caseno === cn) {
				return true;
			}
		}
		return false;
	}

	const openActions = () => {
		navigate('/linkedactions');
	}

	const openTeam = () => {
		navigate('/linkedteam');
	}

	const wishList = () => {
		if (!isCaseOwned(cases.linkedcase.caseno)) { return; }
		if (cases.linkedcase.details && cases.linkedcase.details.wishlisted) {
			dispatch(UI.setWishlistEditPopup({ visible: true, caseno: cases.linkedcase.caseno, casetype: cases.linkedcase.type }));
		} else {
			dispatch(UI.setWishlistPopup({ visible: true, caseno: cases.linkedcase.caseno, casetype: cases.linkedcase.type }));
		}
	}

	const updateDates = () => {
		if (validateForm('ICD', 'ICD')) {
			dispatch(Cases.setUpdatingDates(true));
			const json = getJSONWithFormValues('ICD');
			const data = JSON.parse(json);

			const state: Cases.updateCaseDatesState = {
				caseno: cases.linkedcase.caseno,
				id: user.id,
				usertype: user.type,
				token: user.token,
				casetype: cases.linkedcase.casetype,
				handler: (cases.linkedcase.details ? cases.linkedcase.details.handler : ''),
				valuation_booked: data.valuation_booked.val,
				mortgage_completed: data.mortgage_completed.val,
				valuation_completed: data.valuation_completed.val
			}
			dispatch(Cases.updateCaseDates(state) as unknown as AnyAction).then(() => {
			});
		}
	}

	useEffect(() => {
		dispatch(Forms.setFormValueWithId({
			form: 'ICD',
			type: 'text',
			id: 'valuation_booked',
			val: (cases.linkedcase.IntroducerDates.valuation_booked != null ? cases.linkedcase.IntroducerDates.valuation_booked : '')
		}));
		dispatch(Forms.setFormValueWithId({
			form: 'ICD',
			type: 'text',
			id: 'mortgage_completed',
			val: (cases.linkedcase.IntroducerDates.mortgage_completed != null ? cases.linkedcase.IntroducerDates.mortgage_completed : '')
		}));
		dispatch(Forms.setFormValueWithId({
			form: 'ICD',
			type: 'text',
			id: 'valuation_completed',
			val: (cases.linkedcase.IntroducerDates.valuation_completed != null ? cases.linkedcase.IntroducerDates.valuation_completed : '')
		}));
	}, [cases.linkedcase.IntroducerDates, dispatch]);

	useEffect(() => {
		if (!cases.case.caseno) {
			navigate('/hub');
		}
	}, [])

	return (
		<div className="Home" style={{ position: 'relative' }}>
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
				<div className='OrangeBand'>
					<div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 96, marginRight: 8 }} src={hub_logo} alt='Hub-Logo' />
							<div style={{ marginLeft: 24 }}>
								<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Linked Case {cases.linkedcase.caseno}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="row100" style={{ justifyContent: 'start', alignItems: 'end', position: 'absolute', zIndex: 995 }}>
					{isCaseOwned(cases.linkedcase.caseno) &&
						<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openActions()}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_mainhub} alt='MainHub-Icon' />
								<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Actions</div>
							</div>
							<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
								{cases.isOpeningActions &&
									<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
								}
							</div>
						</div>
					}
					<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openTeam()}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_team} alt='Team-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Meet the Team</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningTeam &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className={(cases.linkedcase.details?.wishlisted ? 'buttonGreenRounded' : 'buttonPurple')} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => wishList()}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 24, height: 24, marginRight: 8 }} src={icon_wishlist} alt='Wishlist-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Wishlist{(cases.linkedcase.details?.wishlisted ? ' - ' + cases.linkedcase.details.wishlisted : '')}</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isWishlisting &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
				</div>
				<div style={{ justifyContent: 'start', alignItems: 'end', position: 'absolute', zIndex: 997, top: 196, width: 220, left: '2%' }}>
					{cases.linkedcase.type !== 'S' && isCaseOwned(cases.linkedcase.caseno) &&
						<div id='ICD' style={{ width: 220 }}>
							<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 16, color: 'black', marginBottom: 8 }}>Introducer Dates</div>
							<div style={{ fontFamily: 'OpenSans-Regular', fontSize: 14, color: 'black', marginBottom: 4 }}>Mortgage Application Completed:</div>
							<input type='date' data-form-id={'ICD'} value={getFormValueWithId('ICD', "mortgage_completed")} name='mortgage_completed' id='mortgage_completed' onChange={(e) => doFormOnChange(e)} />
							<div style={{ fontFamily: 'OpenSans-Regular', fontSize: 14, color: 'black', marginBottom: 4, marginTop: 8 }}>Valuation Booked:</div>
							<input type='date' data-form-id={'ICD'} value={getFormValueWithId('ICD', "valuation_booked")} name='valuation_booked' id='valuation_booked' onChange={(e) => doFormOnChange(e)} />
							<div style={{ fontFamily: 'OpenSans-Regular', fontSize: 14, color: 'black', marginBottom: 4, marginTop: 8 }}>Valuation Completed:</div>
							<input type='date' data-form-id={'ICD'} value={getFormValueWithId('ICD', "valuation_completed")} name='valuation_completed' id='valuation_completed' onChange={(e) => doFormOnChange(e)} />
							<div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: 8 }}>
								<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => updateDates()}>
									<div style={{ display: 'flex' }}>
										<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', marginLeft: 24 }}>Update</div>
									</div>
									<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
										{cases.isUpdatingDates &&
											<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
										}
									</div>
								</div>
							</div>
						</div>
					}
					{(cases.linkedcase.type === 'S' || !isCaseOwned(cases.linkedcase.caseno)) &&
						<div style={{ width: 242 }}></div>
					}
				</div>
				{isTabletOrMobile &&
					<div style={{ position: 'absolute', zIndex: 999, bottom: 8, left: 8, width: 128 }}>
						<TrackerPercent data={cases.case} size={128} />
					</div>
				}
				{!isTabletOrMobile &&
					<div style={{ position: 'absolute', zIndex: 999, top: 212, left: 'calc(2% + 240px)', width: 128 }}>
						<TrackerPercent data={cases.case} size={128} />
					</div>
				}
				<div style={{ position: 'absolute', display: 'flex', left: '30%', right: 0, bottom: 0, justifyContent: (isTabletOrMobile ? 'end' : 'center'), overflowY: 'scroll', overflowX: 'hidden' }} onScroll={handleScroll}>
					{isTabletOrMobile &&
						<div className="flexGrow2" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<TrackerChart data={cases.case} size={640} />
						</div>
					}
					{!isTabletOrMobile &&
						<div className="flexGrow2" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
							<TrackerChart data={cases.case} size={640} />
						</div>
					}
				</div>
			</div>

			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default LinkedCase;